import React, { Component } from 'react';
import textDocInteg from '../../doc/widsfs.md';
import DocIntegrationMain from './DocIntegrationMain';

class DocIntegrationWidSFS extends Component {

    constructor(props) {
        super(props)
        this.state = { textDocInteg: null }
    }

    componentDidMount() {
        fetch(textDocInteg).then((response) => response.text()).then((text) => {
            this.setState({ textDocInteg: text })
        })
    }

    headingsHash = [];

    render() {
        return (
            <DocIntegrationMain textDocInteg={this.state.textDocInteg} id="modalDocWidSFS" />
        )
    }
}

export default (DocIntegrationWidSFS);
